module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-2572961ab2e263c79c5c59482bdbd889.webp";